import { useCallback } from 'react';

import { FieldValues } from 'react-hook-form';

import { get } from 'radash';

import { isEmpty, isNotDefined } from '@hsp/utilities';

import { FORM_NAMES, ISelectedFilter } from 'types/api/audience';
import { IClientList } from 'types/api/client-list';
import { IClientListReturn } from 'types/pages/audience-builder/shared/hooks/client-lists';

export const useClientLists = () => {
  return useCallback((fieldValues: FieldValues): IClientListReturn => {
    const allClientLists = get<IClientList[]>(fieldValues, FORM_NAMES.UseClientLists);
    const all = allClientLists ?? [];
    const formValue = get<ISelectedFilter<IClientList>>(fieldValues, FORM_NAMES.Lists);

    if (isNotDefined(formValue)) {
      return {
        excludeInclude: [],
        use: [],
      };
    }

    const { filters, type } = formValue;

    if (type === 'include') {
      if (isEmpty(filters)) {
        return { excludeInclude: [], use: all };
      }

      return { excludeInclude: filters, use: filters };
    }

    const ids = filters.map(({ id }) => id);

    if (isEmpty(filters)) {
      return {
        excludeInclude: all,
        use: allClientLists?.filter(({ id }) => ids.includes(id)) ?? [],
      };
    }

    return {
      excludeInclude: filters,
      use: allClientLists?.filter(({ id }) => !ids.includes(id)) ?? [],
    };
  }, []);
};
